import { render, staticRenderFns } from "./ExistingDamage.vue?vue&type=template&id=059842d0&scoped=true"
import script from "./ExistingDamage.vue?vue&type=script&lang=js"
export * from "./ExistingDamage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059842d0",
  null
  
)

export default component.exports